import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReservationExpandedSummaryViewComponent } from './reservation-expanded-summary-view.component';
@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild()
  ],
  exports: [ReservationExpandedSummaryViewComponent],
  declarations: [ReservationExpandedSummaryViewComponent]
})
export class ReservationExpandedSummaryViewModule {}
